
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import news from "../../static/images/news.jpg"
import { Link } from 'react-router-dom';
export default function App() {
  const data =[
    {
      link:'/newd',
      name:'著名书法家燕霜红先生为公司成立8周年题词',
      content:'国内著名书法家、诗人燕霜红先生欣然挥毫，为深圳市远东数智采技术服务有限公司公司成立 8 周年精心创作书法题词，以翰墨雅韵为企业发展送上诚挚祝福',
      time:'2025-12-09',
    },
    {
      link:'/newb',
      name:'公司荣获用友第七届企业数智化创新应用开发大赛“最佳行业方案奖”！',
      content:'深圳市远东数智采技术服务有限公司荣获用友第七届企业数智化创新应用开发大赛中荣获大中型企业赛道“最佳行业方案奖”',
      time:'2025-11-19',
    },
    {
      link:'/newa',
      name:'深圳远东数智采技术服务有限公司董事长胡敏成一行到访中物联',
      content:'2025年11月10日，深圳市远东数智采技术服务有限公司董事长胡敏成一行到访中国物流与采购联合会，中国物流与采购联合会副会长何辉接待来访。',
      time:'2025-11-10',
    },
    {
      link:'/new',
      name:'用友与深圳远东数智采共同推出的公共资源交易行业垂类大模型入选“北京首批‘人工智能+’应用场景典型案例',
      content:'8月19日，由北京市发展和改革委员会、北京市科学技术协会、北京市海淀区人民政府等主办的2024北京人工智能生态大会在北京中关村国家自主创新示范区隆重举行，大会围绕大模型、具身智能、可信AI等国内外前沿热点话题展开深入探讨',
      time:'2024-08-19',
    },
    {
      link:'/newc',
      name:'深圳市远东数智采技术服务有限公司（中国招标投标协会委员单位）参与协会第二届招标采购数字化专业委员会换届会议暨第一次工作会议',
      content:'为深入学习贯彻党的二十大及二十届二中全会精神，加快建设全国统一大市场，深化要素市场化改革，建设高标准市场体系，积极推动招标采购数字化水平，促进行业数字化转型，4月19日，中国招标投标协会第二届招标采购数字化专业委员会换届会议暨第一次工作会议在宁波召开',
      time:'2024-04-28',
    },
  ]
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'3'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsList'>
          <div className='newsList-left'><Link to='/new'><img src={news} /></Link></div>
          <div className='newsList-right'>
            <ul>
              {data.map((item)=>{
                return <li>
                  <h3><Link to={item.link}>{item.name}</Link></h3>
                  <div className='text'>{item.content}</div>
                  <div className='bottom'><Link to={item.link}>阅读全文</Link><span>发布时间：{item.time}</span></div>
                </li>
              })}
            </ul>
          </div>
        </div>
      </PageBox>
    </>
    
  );
}
